import {
  addErrorMessage,
  addPositiveMessage,
} from '@greenkub-fronts/domain/snackbar';

import { createAsyncThunk } from '@reduxjs/toolkit';

export const onCustomerSign = createAsyncThunk(
  'onCustomerSign',
  async (
    data: {},
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    const {
      isSignature,
      fromExisting,
      toGenerate,
      signature,
      documentSlug,
      upsell,
      project,
    } = getState().signature;

    let { isDocumentLoaded } = getState().signature;
    const { document } = getState().signature;

    if (!isSignature) return;

    let result;

    if (fromExisting) {
      result = await dispatch(
        extra.apiSlice.endpoints.patchSignatureExistingDoc.initiate({
          documentId: document.id,
          data: { signature },
        })
      );
    } else if (toGenerate) {
      const entityIdentifier =
        documentSlug === 'upsell' ? upsell.id : project.id;
      result = await dispatch(
        extra.apiSlice.endpoints.patchSignatureGeneratingDoc.initiate({
          documentId: entityIdentifier,
          data: { signature, documentSlug },
        })
      );
    }

    let respData;

    if (result.data) {
      respData = result.data;
      isDocumentLoaded = false;
      dispatch(addPositiveMessage('Document signé'));
    } else {
      dispatch(addErrorMessage('Problème de signature'));
    }

    return {
      isDocumentLoaded,
      document,
      documentId: respData.data.documentId,
    };
  }
);

export default onCustomerSign;
